var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDialerEndCall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 75,
    viewBox: "0 0 110 110"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 55.5,
    cy: 54.5,
    r: 51.5,
    fill: "#E74C3C",
    stroke: "#E74C3C"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M33.515 37.062c2.444-2.443 5.736-4.348 9.777-5.667 3.732-1.215 7.976-1.857 12.277-1.848 4.3 0 8.54.646 12.276 1.866 4.041 1.318 7.333 3.223 9.777 5.666 1.581 1.581 1.637 4.585 1.59 5.804-.074 1.754-.53 4.167-1.573 5.21-.517.517-1.465.784-2.982.844-1.129.043-2.525-.034-4.037-.22-.91-.116-5.511-.745-6.77-2.003-1.03-1.03-.581-2.909-.107-4.9.185-.77.374-1.564.443-2.21.074-.685-.017-.913-.038-.96-4.572-1.953-12.57-1.953-17.141 0-.022.038-.117.262-.04.96.074.642.26 1.44.445 2.21.474 1.991.922 3.87-.108 4.9-1.258 1.258-5.86 1.887-6.774 2-1.508.189-2.904.266-4.037.219-1.513-.056-2.46-.323-2.978-.84-1.042-1.043-1.503-3.46-1.577-5.214-.051-1.224-.004-4.236 1.577-5.817zm22.712 51.405l11.189-11.19a.932.932 0 00-1.319-1.318L56.5 85.556V55.172a.932.932 0 00-1.865 0v30.384l-9.597-9.597a.932.932 0 10-1.319 1.319l11.19 11.189a.932.932 0 001.318 0z"
  }))));
}

export default SvgDialerEndCall;